export default function AwsActivateHeroVisual() {
  const src = `${process.env.PUBLIC_URL || ""}/img/aws-activate-hero.png`;

  return (
    <div className="aws-hero-visual">
      <div className="aws-hero-visual-panel">
        <img
          src={src}
          alt="Startup team collaborating on AWS cloud infrastructure"
          className="aws-hero-img"
          loading="eager"
          decoding="async"
        />
      </div>
    </div>
  );
}
